export const DEFAULT_PREDICATE_ID_FOR_FORMAT_COLUMN = 'NonBlanks';
